module.exports = "#clone-button {\r\n    float: right;\r\n    position: fixed;\r\n    top: 95px;\r\n    right: 25px;\r\n}"